export default {
  info: {},
  list: [],
};